import script from "./HeaderMenuTest.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMenuTest.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMenuTest.vue?vue&type=style&index=0&id=f558570c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f558570c"]])

export default __exports__